import { useEffect, useRef } from 'react';
import { typingText } from 'root/utils/typingText';
import { selectApp } from 'store/app/slice';
import { useTypedSelector } from 'hooks/useStore';
import Button from 'ui/Button/Button';
import './Content.scss';

const Content: React.FC = (props) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const descRef = useRef<HTMLParagraphElement>(null);
  const { isIntro } = useTypedSelector(selectApp);

  useEffect(() => {
    if (!isIntro) {
      if (titleRef.current && descRef.current) {
        typingText<HTMLHeadingElement>(titleRef.current, 2000).startDelay(750);
        typingText<HTMLParagraphElement>(descRef.current, 4500).startDelay(
          1000
        );
      }
    }
  }, [isIntro]);

  return (
    <div className="hero-content__wrapper">
      <div className="hero-content">
        <div className="hero-content__introduce">
          <h3 className="hero-content__suptitle">Introducing Get Set Play</h3>
          <h2 className="hero-content__title" ref={titleRef}>
            A complete ecosystem <span>just for gamers</span>
          </h2>
        </div>
        <div className="hero-content__about">
          <p className="hero-content__description" ref={descRef}>
            For the World’s first DAO-powered eSport and Streaming multiverse,
            the stakes are high and that is why you should get set to play!
          </p>
          <Button
            className="hero-content__btn"
            title="Start"
            variant="gray"
            to="/"
          />
        </div>
      </div>
    </div>
  );
};

export default Content;
